import { BookNowButton, LabChip } from "./Shared";
import { Check } from "lucide-react";

const POINTS = [
  "Trained, vetted, insured technicians",
  "Non-toxic, pet-and-family-safe formulas",
  "Checklist-driven quality assurance",
  "Flexible one-time or recurring schedules",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        {/* Image panel */}
        <div className="lg:col-span-6 relative">
          <div className="relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5] max-w-sm mx-auto lg:mx-0">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/4084ec3b-9da1-44ac-a188-fcf31cb9d461/images/86ce3b506b92db2cdab4d129bb890ba20aa8de5759084c9042a34a220913ee88.png"
              alt="Precision cleaning"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
              <div>
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#00E5FF]">
                  Specimen 017
                </div>
                <div className="mt-1 font-display text-base text-white">
                  Post-turnover verification
                </div>
              </div>
              <div className="font-mono text-[10px] text-white/40">
                pass · 99.4%
              </div>
            </div>
          </div>

          {/* Floating stat card */}
          <div className="hidden sm:flex absolute -bottom-6 right-0 lg:right-auto lg:left-[55%] bg-[#0A0A0A] border border-white/15 rounded-2xl p-4 w-52 shadow-xl backdrop-blur-lg">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">
                Signature blend
              </div>
              <div className="mt-1 font-display text-base text-white leading-snug">
                Citrus · Oxy · Plant-Enzyme
              </div>
              <div className="mt-3 h-1.5 w-full bg-white/10 rounded-full overflow-hidden">
                <div className="h-full w-[92%] bg-[#00E5FF]" />
              </div>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="lg:col-span-6">
          <LabChip testId="about-chip">About · The Neat Lab</LabChip>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
            Cleaning treated like{" "}
            <span className="italic font-light text-white/60">chemistry,</span>{" "}
            <span className="text-[#00E5FF]">not chores.</span>
          </h2>
          <p className="mt-6 text-white/60 font-body text-base sm:text-lg leading-relaxed">
            The Neat Lab was built on a single belief: great cleaning is a
            discipline, not a favor. Every protocol we run is formulated,
            timed, and verified — so your space is handed back measurably
            better than we found it.
          </p>

          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li
                key={p}
                className="flex items-start gap-3 text-white/75 font-body text-[15px]"
              >
                <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#00E5FF]/10 text-[#00E5FF] shrink-0">
                  <Check size={13} strokeWidth={3} />
                </span>
                {p}
              </li>
            ))}
          </ul>

          <div className="mt-10">
            <BookNowButton variant="primary" testId="about-book-now" />
          </div>
        </div>
      </div>
    </section>
  );
};
